import { sec } from './units.ts';

/** Kaela of the Moss (druid): she called the forest, and the forest came late (docs/ANTIHEROES.md). */
export const KAELA = {
  /** Her blow from afar (a thorn shot) reaches this far; each at least `blowMaxHpBp` of the struck hero's max health. */
  shot: { range: 5000, maxHpBp: 700 },
  /**
   * The Late Forest (passive): a hero within `range` of her that stands still `stillTicks` is gripped by roots — held
   * `ticks` (stunned) and hurt (`damage` or `maxHpBp`). Every `mossEvery`, the `mossTowers` towers nearest her within
   * `mossRange` are wrapped in moss, silent `mossTicks` (nothing cuts it).
   */
  roots: { range: 7000, stillTicks: sec(2), ticks: sec(1.5), damage: 40, maxHpBp: 800 },
  moss: { every: sec(10), towers: 2, range: 9000, ticks: sec(5) },
  /** Thorns: marks under `count` heroes (more from 66 %) that burst after `warn` — `damage` or `maxHpBp` on whoever stands in one. */
  thorns: { every: sec(6), range: 8000, count: 2, countLater: 3, warn: sec(1.5), radius: 1100, damage: 60, maxHpBp: 1600 },
  /** The Pack: `count` wolves (more from 66 %) around a hero within `range`, hunting it; tougher (`hpBp`) and biting by her strength. */
  pack: { every: sec(14), range: 8000, count: 3, countLater: 4, ring: 1200, hpBp: 40000, hunt: sec(8) },
  /**
   * The Forest Comes (ultimate): an enormous circle around her. It lands: every hero inside held `holdTicks` and hurt
   * (`damage` or `maxHpBp`), every tower inside wrapped `mossTicks`, and she mends `healBp` of her life over `healTicks`.
   */
  forest: { radius: 6500, holdTicks: sec(2.5), damage: 180, maxHpBp: 3500, mossTicks: sec(8), healBp: 1200, healTicks: sec(4) },
  /** Bear form from 33 %: she fights up close, her blows land `blowBp` harder (each at least `blowMaxHpBp`), she takes `takenBp`, and walks `speedBp`. */
  bear: { blowBp: 16000, blowMaxHpBp: 1100, takenBp: 7500, speedBp: 12000 },
};
